import { Box, Stack } from "@mui/material";
import React from "react";
import { TextView } from "@components";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { colors } from "../../../../utils";
import { ASSETS } from "../../../../utils/config";

function LabelHeader({ onBack, onHamburgerIconClick }) {
  return (
    <Stack
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      alignItems={"center"}
      px={2}
      sx={{
        height: "5vh",
        width: "100vw",
        mb: -1,
        mt: 3,
      }}
    >
      <KeyboardBackspaceIcon
        style={{ fontSize: "3.5vh" }}
        onClick={() => onBack()}
      />
      <TextView
        style={{ fontWeight: "500", color: colors.primary, fontSize: "2vh" }}
      >
        Labels View
      </TextView>
      <Box
        onClick={onHamburgerIconClick}
        sx={{
          height: "30px",
          width: "30px",
          borderRadius: "50%",
          backgroundColor: "#F6F7F9",
        }}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <img src={ASSETS.Hamburger} onClick={onHamburgerIconClick} alt="ham" />
      </Box>
    </Stack>
  );
}

export default LabelHeader;
